import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=79c479cc&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=79c479cc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c479cc",
  null
  
)

export default component.exports